import { useContext } from "react";
import { DesktopClientContext } from "./context";

export function useDesktopClientContext() {
  return useContext(DesktopClientContext);
}
